import { render, staticRenderFns } from "./selectCourse.vue?vue&type=template&id=2abbeb2c"
import script from "./selectCourse.vue?vue&type=script&lang=js"
export * from "./selectCourse.vue?vue&type=script&lang=js"
import style0 from "./selectCourse.vue?vue&type=style&index=0&id=2abbeb2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports